import { useState, useRef, useEffect } from 'react'
import { ConvertPriceToString } from '../../../Helpers/CustomConverter'
import { FaRegEdit } from 'react-icons/fa'
import { IoClose } from "react-icons/io5"
import { handleInputKeyPressForQtyAndValueInput, handleInputForQtyAndValueFocus, handleOnChangeForQtyAndValueInput } from '../../../Helpers/PriceAndValueInputHelpers'
import useGetProductIndexWithMask from '../../../Components/BasketPage/Hooks/useGetProductIndexWithMask'
import { FaCheck } from "react-icons/fa6";
import { useParams } from '../../../Providers/ParamsProvider.jsx'
import { getIndeksHeader } from '../../../Helpers/ValidatorHelper.jsx'
import { toast } from 'react-toastify'
import { useCart } from '../../../Providers/CartProvider.jsx'

const OfferRequestRetailerOfferTable = ({ products, setProducts, handleRemoveProduct, retailerTax, handleUpdateSavedOfferAfterEdit }) => {
    const { license, isMobile } = useParams()

    if (!products || products.length === 0) {
        return <span className='error-text-color '>Brak produktów, dodaj pozycję do koszyka i wróć do tego okna.</span>
    }
    return (
        <div className='table-responsive'>
            <table className={`${isMobile ? 'table-font-small' : ''} table table-bordered`}>
                <thead>
                    <tr className='border-bottom border-top'>
                        <th style={{ width: "4%" }}>LP</th>
                        <th style={{ width: "10%" }}>{getIndeksHeader(license)}</th>
                        <th style={{ width: "auto" }}>NAZWA CECHA</th>
                        <th style={{ width: "13%" }}>CENA ZAKUPU PLN</th>
                        <th style={{ width: "8%" }}>NARZUT %</th>
                        <th style={{ width: "10%" }}>CENA DLA KLIENTA PLN</th>
                        <th style={{ width: "5%" }}>ILOŚĆ</th>
                        <th style={{ width: "13%" }}>SUMA NETTO PLN SUMA BRUTTO PLN</th>
                        <th style={{ width: "4%" }}></th>
                        <th style={{ width: "4%" }}></th>
                    </tr>
                </thead>
                <tbody>
                    {products.map((p, key) => (
                        <ProductsTableContent
                            key={key}
                            lp={key}
                            basketItem={p}
                            handleRemoveProduct={handleRemoveProduct}
                            setProducts={setProducts}
                            retailerTax={retailerTax}
                            handleUpdateSavedOfferAfterEdit={handleUpdateSavedOfferAfterEdit}
                        />
                    ))}
                    <TableDataSummary
                        basketItems={products}
                        setProducts={setProducts}
                        retailerTax={retailerTax}
                        handleUpdateSavedOfferAfterEdit={handleUpdateSavedOfferAfterEdit}
                    />
                </tbody>
            </table>
        </div>
    )
}

const ProductsTableContent = ({ lp, basketItem, handleRemoveProduct, setProducts, retailerTax, handleUpdateSavedOfferAfterEdit }) => {
    const [initialMarkup, setInitialMarkup] = useState(isNaN(basketItem.retailerMarkup) ? 0 : basketItem.retailerMarkup)
    const [initialQty, setInitialQty] = useState(basketItem.qty)
    const [initialPriceNet, setInitialPriceNet] = useState(basketItem.product.priceNet)

    const { getProductIndexWithMask } = useGetProductIndexWithMask()
    const [isEditMode, setIsEditMode] = useState(false)
    const inputRef = useRef(null)
    const decimalPlaces = basketItem.product.decimalPlaces

    const handleInputKeyPress = (event) => {
        if (!handleInputKeyPressForQtyAndValueInput(event, decimalPlaces)) {
            event.preventDefault()
            return
        }
    }
    const handleInputOnChange = (e) => {
        if (!handleOnChangeForQtyAndValueInput(e, decimalPlaces)) {
            e.preventDefault()
            return
        }
        const newQty = parseFloat(e.target.value).toFixed(decimalPlaces)
        setProducts(prevProducts =>
            prevProducts.map(item =>
                item.product.index === basketItem.product.index ? { ...item, qty: parseFloat(newQty) } : item
            ))
    }
    const handleMarkupChange = (e) => {
        if (!handleOnChangeForQtyAndValueInput(e, 2)) {
            e.preventDefault()
            return
        }
        setProducts(prev =>
            prev.map(item =>
                item.product.index === basketItem.product.index ? { ...item, retailerMarkup: parseFloat(e.target.value) } : item
            ))
    }
    const handlePriceChange = (e) => {
        if (!handleOnChangeForQtyAndValueInput(e, 2)) {
            e.preventDefault()
            return
        }
        setProducts(prev =>
            prev.map(item =>
                item.product.index === basketItem.product.index
                    ? {
                        ...item,
                        costNet: parseFloat(e.target.value),
                        costGross: parseFloat(e.target.value * (1 + retailerTax / 100)),
                        product: {
                            ...item.product,
                            priceNet: parseFloat(e.target.value),
                            priceGross: parseFloat(e.target.value * (1 + retailerTax / 100))
                        }
                    }
                    : item
            ))
    }
    const handlePriceLostFocus = (e) => {
        e.target.value = parseFloat(e.target.value).toFixed(2)
    }
    const handlePriceKeydown = (e) => {
        if (!handleInputKeyPressForQtyAndValueInput(e, 2)) {
            e.preventDefault()
            return
        }
    }
    const handleRemoveProductInternalFunc = (e, index) => {
        if (isEditMode) {
            e.preventDefault()
            setIsEditMode(false)
            setProducts(prev =>
                prev.map(item =>
                    item.product.index === index
                        ? {
                            ...item,
                            retailerMarkup: initialMarkup,
                            qty: initialQty,
                            product: {
                                ...item.product,
                                priceNet: parseFloat(initialPriceNet)
                            }
                        }
                        : item
                ))
            return
        }
        else {
            handleRemoveProduct(index)
        }
    }
    const handleChangeEditMode = (itemQty, retailerMarkup, priceNet) => {
        if (isEditMode) {
            if (isNaN(itemQty)) {
                toast.warning('Prosze uzupełnić pole ilość!')
                return
            }
            if (isNaN(retailerMarkup)) {
                toast.warning('Prosze uzupełnić pole narzut!')
                return
            }
        }
        setNewInitialValues(itemQty, retailerMarkup, priceNet)
        setIsEditMode(prev => !prev)
        if (isEditMode) { //po wyjściu e zdycji
            handleUpdateSavedOfferAfterEdit()
        }
    }

    //DK : Nadpisujemy init value po zatwierdzeniu ptaszkiem by do tego cofnąć X
    const setNewInitialValues = (itemQty, retailerMarkup, priceNet) => {
        setInitialMarkup(retailerMarkup)
        setInitialQty(itemQty)
        setInitialPriceNet(priceNet)
    }

    const rowBackgroundColorStyle = basketItem.externalArticle ? 'own-product-highlight' : ''

    return (
        <tr className={`${rowBackgroundColorStyle}`}>
            <td>{lp + 1}</td>
            <td>{getProductIndexWithMask(basketItem.product.index)}</td>
            <td>{basketItem.product.title + basketItem.product.label}</td>

            {isEditMode && basketItem.externalArticle ? (<td style={{ textAlign: 'right' }}>
                <input type='number' value={basketItem.product.priceNet} min={0} max={9999999} className='biggerArrows offer-request-input' style={{ width: '100px' }}
                    onFocus={(e) => handleInputForQtyAndValueFocus(e)} onChange={handlePriceChange} onBlur={handlePriceLostFocus} onKeyDown={handlePriceKeydown} />
            </td>)
                : (<td style={{ textAlign: 'right' }}>{ConvertPriceToString(basketItem.product.priceNet, null)}</td>)}

            {isEditMode && !basketItem.externalArticle ? (<td style={{ textAlign: 'right' }}>
                <input type='number' value={basketItem.retailerMarkup} min={0} max={100} className='biggerArrows offer-request-input' style={{ width: '100px' }}
                    onFocus={(e) => handleInputForQtyAndValueFocus(e)} onChange={handleMarkupChange} />
            </td>) : (<td style={{ textAlign: 'right' }}>{`${basketItem.retailerMarkup}`}</td>)}


            <td style={{ textAlign: 'right' }}>{ConvertPriceToString(basketItem.product.priceNet + (basketItem.product.priceNet * basketItem.retailerMarkup / 100), null)}</td>

            {isEditMode ? (<td style={{ textAlign: 'right' }}>
                <input type='number' value={basketItem.qty} min={0} max={9999999} className='biggerArrows offer-request-input' style={{ width: '100px' }} step={Math.pow(10, -decimalPlaces)} ref={inputRef}
                    onFocus={(e) => handleInputForQtyAndValueFocus(e)} onKeyDown={handleInputKeyPress} onChange={handleInputOnChange} />
            </td>) : (<td style={{ textAlign: 'right' }}>{basketItem.qty}</td>)}

            <td style={{ textAlign: 'right' }}>
                <div className='d-flex flex-column'>
                    <b>{ConvertPriceToString(((basketItem.costNet + (basketItem.costNet * basketItem.retailerMarkup / 100)).toFixed(2) * basketItem.qty).toFixed(2), null)}</b>
                    <span>{ConvertPriceToString((((basketItem.costNet + (basketItem.costNet * basketItem.retailerMarkup / 100)).toFixed(2) * basketItem.qty).toFixed(2) * (1 + (retailerTax / 100))).toFixed(2), null)}</span>
                </div>
            </td>
            <td>
                {isEditMode ? (<FaCheck cursor={'pointer'} size={25} onClick={() => handleChangeEditMode(basketItem.qty, basketItem.retailerMarkup, basketItem.product.priceNet)} color='var(--success-color)' />) :
                    (<FaRegEdit cursor={'pointer'} size={25} onClick={() => handleChangeEditMode(basketItem.qty, basketItem.retailerMarkup, basketItem.product.priceNet)} />)}
            </td>
            <td><IoClose cursor={'pointer'} size={25} onClick={(e) => handleRemoveProductInternalFunc(e, basketItem.product.index)} color='var(--error-color)' /></td>
        </tr>
    )
}

const TableDataSummary = ({ basketItems, setProducts, retailerTax, handleUpdateSavedOfferAfterEdit }) => {
    const [allItemsMarkup, setAllItemsMarkup] = useState("")
    const { round2 } = useCart()

    useEffect(() => {
        if (allItemsMarkup.trim() === '') {
            return
        }

        setProducts(prev =>
            prev.map(product =>
                product.externalArticle === false
                    ? { ...product, retailerMarkup: parseFloat(allItemsMarkup) }
                    : product
            ))
    }, [allItemsMarkup])

    const totalQty = basketItems.reduce((acc, item) => acc + item.qty, 0)

    const totalNetValue = basketItems.reduce((acc, item) => {
        const priceWithMarkup = round2(item.costNet + (item.costNet * item.retailerMarkup / 100));
        const roundedUnitPrice = round2(priceWithMarkup);
        const lineValue = round2(roundedUnitPrice * item.qty);
        return acc + round2(lineValue);
    }, 0);

    const finalTotal = round2(totalNetValue);
    const taxRate = retailerTax / 100
    const totalGrossValue = round2(finalTotal * (1 + taxRate))

    const handleMarkupForAllItemsChange = (e) => {
        if (!handleOnChangeForQtyAndValueInput(e, 2)) {
            e.preventDefault()
            return
        }
        setAllItemsMarkup(e.target.value)
    }

    const handleUpdateSavedOfferAfterChangeAllItemsMarkup = () => {
        handleUpdateSavedOfferAfterEdit()
    }

    return (
        <tr>
            <td></td>
            <td></td>
            <td></td>
            <td colSpan={3}>
                <input type='number' value={allItemsMarkup} className='biggerArrows offer-request-input' placeholder='Narzut dla wszystkich pozycji' min={0} max={999}
                    onFocus={(e) => handleInputForQtyAndValueFocus(e)} onChange={(e) => handleMarkupForAllItemsChange(e)} onBlur={handleUpdateSavedOfferAfterChangeAllItemsMarkup} />
            </td>
            <td style={{ textAlign: 'right' }}>{isNaN(totalQty) ? 0 : totalQty}</td>
            <td style={{ textAlign: 'right' }}>
                <div className='d-flex flex-column'>
                    <b>{ConvertPriceToString(round2(totalNetValue), null)}</b>
                    <span>{ConvertPriceToString(totalGrossValue, null)}</span>
                </div>
            </td>
            <td></td>
            <td></td>
        </tr>
    )
}

export default OfferRequestRetailerOfferTable